import type { TFunction } from 'i18next';
import type { Property } from '@vuokramani/shared';
import type { DetailRow } from '../../components/page.tsx';
import { formatPercentFromBp } from '../../lib/properties.ts';

/**
 * Asunnon tietorivit yhdessä paikassa, jotta vuokranantajan ja vuokralaisen näkymät pysyvät
 * samoina. Vuokranantaja näkee kaikki rivit ja silmän vuokralaiselle näkyvien kohdalla;
 * vuokralainen näkee vain jaetut rivit.
 */
const DASH = '–';

export function homeRows(p: Property, t: TFunction, lang: string): DetailRow[] {
  return [
    {
      label: t('property.fields.address'),
      value: `${p.streetAddress}, ${p.postalCode} ${p.city}`,
      shared: true,
    },
    { label: t('property.fields.type'), value: t(`propertyTypes.${p.type}`) },
    {
      label: t('property.fields.buildingType'),
      value: p.buildingType ? t(`buildingTypes.${p.buildingType}`) : DASH,
      shared: true,
    },
    { label: t('property.fields.rooms'), value: p.roomLayout ?? DASH, shared: true },
    {
      label: t('property.fields.area'),
      value: p.areaM2 ? `${p.areaM2.toLocaleString(lang)} m²` : DASH,
      shared: true,
    },
    { label: t('property.fields.floor'), value: p.floor ?? DASH, shared: true },
    { label: t('property.fields.buildYear'), value: p.buildYear ?? DASH, shared: true },
    {
      label: t('property.fields.ownership'),
      value: p.myOwnershipBp !== null ? `${formatPercentFromBp(p.myOwnershipBp, lang)} %` : DASH,
    },
  ];
}

export function companyRows(p: Property, t: TFunction): DetailRow[] {
  return [
    { label: t('property.fields.housingCompany'), value: p.housingCompany ?? DASH, shared: true },
    { label: t('property.fields.businessId'), value: p.housingCompanyBusinessId ?? DASH },
  ];
}

/** Vuokralaiselle vain jaetut rivit, ilman silmämerkintää. */
export function sharedOnly(rows: DetailRow[]): DetailRow[] {
  return rows.filter((r) => r.shared).map(({ shared: _shared, ...r }) => r);
}
